import HeartFilled from '../../src/legacy/HeartFilled.tsx';
export default HeartFilled;
